/*global chmln*/
import config from 'config'

let _loaded = false
let _userIdentifiedPromise

function init() {
	if (_loaded) {
		return
	}
	_loaded = true;
	(function(t, n, o) {
		const a = 'chmln',
			e = 'adminPreview',
			c = 'setup identify alias track clear set show on off custom help _data'.split(' ')
		if ((n[a] || (n[a] = {}), n[a][e] && (n[a][e] = !1), !n[a].root)) {
			(n[a].accountToken = o), (n[a].location = n.location.href.toString()), (n[a].now = new Date())
			for (let s = 0; s < c.length; s++)
				!(function() {
					const t = (n[a][c[s] + '_a'] = [])
					n[a][c[s]] = function() {
						t.push(arguments)
					}
				})()
			const i = t.createElement('script');
			(i.src = 'https://fast.trychameleon.com/messo/' + o + '/messo.min.js'), (i.async = !0), t.head.appendChild(i)
		}
	})(document, window, config.chameleon.clientId)
}


function identifyUser(presenterUid, userProperties) {
	if (!_userIdentifiedPromise) {
		_userIdentifiedPromise = new Promise(function(resolve) {
			if (typeof chmln !== 'undefined') {
				// Avoid using chameleon for non-B2B users
				if (!userProperties.isChameleonEnabled) {
					chmln.elusive = 'user'
				} else {
					chmln.identify(presenterUid,
						{
							...userProperties,
						}
					)
				}
				resolve()
			} else {
				resolve()
			}
		})
	}
	return _userIdentifiedPromise
}

function track(event) {
	return new Promise(function(resolve) {
		if (typeof chmln !== 'undefined') {
			chmln.track(event)
		}
		resolve()
	})
}

export default {
	init,
	identify: identifyUser,
	track,
}
